export const INQUIRY_SERVICES = ['Towing', 'Winching / recovery', 'Lockout', 'Jump start', 'Tire change', 'Fuel delivery', 'Specialty transport'];
export const initialInquiry = { kind: 'service', name: '', phone: '', email: '', location: '', destination: '', vehicle: '', service: 'Towing', details: '', website: '' };

export async function sendInquiry(form, requestId, fetcher = fetch) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetcher('/api/inquiries', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...form, requestId }), signal: controller.signal,
      credentials: 'same-origin',
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || data?.ok !== true || !/^[0-9a-f-]{36}$/i.test(data?.requestId || '') || !/^WEB-[A-Z0-9-]{6,40}$/.test(data?.reference || '')) {
      throw new Error(data?.error || 'We could not confirm that your request was saved. Retry once or call/text dispatch.');
    }
    return { requestId: data.requestId, reference: data.reference, duplicate: data.duplicate === true };
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('Delivery could not be confirmed yet. Your details are still here. Retry with this form or call/text dispatch.');
    throw error;
  } finally { clearTimeout(timeout); }
}

export const INQUIRY_SERVICE_BY_SLUG = Object.freeze({
  'flatbed-towing': 'Towing',
  'local-towing': 'Towing',
  'vehicle-recovery': 'Winching / recovery',
  'lockout-assistance': 'Lockout',
  'jump-starts': 'Jump start',
  'tire-changes': 'Tire change',
  'fuel-delivery': 'Fuel delivery',
  'specialty-transport': 'Specialty transport',
});

export function inquiryServiceForSlug(slug) {
  return Object.hasOwn(INQUIRY_SERVICE_BY_SLUG, slug) ? INQUIRY_SERVICE_BY_SLUG[slug] : null;
}
